import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-heading font-bold text-white whitespace-nowrap">
                  久久影视
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                热门电视剧全集免费在线观看，高清不卡顿，追剧首选平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-categories" className="hover:text-primary-400 transition-colors">剧集分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(1, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-more" className="hover:text-primary-400 transition-colors">更多分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    用户口碑
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 久久影视 - 热门电视剧全集免费在线观看平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">
                DMCA
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}